'use client';
import MadfuWidget from '@/components/installments-widgets/madfu-widget';
import MisPayWidget from '@/components/installments-widgets/mispay-widget';
import TabbyWidget from '@/components/installments-widgets/tabby-widget';
import TamaraWidget from '@/components/installments-widgets/tamara-widget';
import { validatePrice } from '@/utils/category';
import { useLocale } from 'next-intl';
import EmkanWidget from './emkan-widget';

const WidgetsWrapper = ({
  fromPDP = false,
  buttonLocation = fromPDP ? 'pdp' : 'cart',
  price: priceWithTax,
  eligible_tabby,
  eligible_tamara,
}) => {
  const locale = useLocale();
  const price = fromPDP ? validatePrice(priceWithTax) : priceWithTax;
  const amount = fromPDP
    ? price?.specialPrice || price?.originalPrice
    : priceWithTax;

  const isShowTamara = true;
  // +total >= +process.env.NEXT_PUBLIC_TAMARA_MIN_VALUE &&
  // +total <= +process.env.NEXT_PUBLIC_TAMARA_MAX_VALUE;
  const isShowTabby = true;
  // +total >= +process.env.NEXT_PUBLIC_TABBY_MIN_VALUE &&
  // +total <= +process.env.NEXT_PUBLIC_TABBY_MAX_VALUE;

  return (
    <div className='space-y-3 sm:space-y-2'>
      {isShowTamara && eligible_tamara && (
        <TamaraWidget {...{ locale, amount, buttonLocation }} />
      )}
      {isShowTabby && eligible_tabby && (
        <TabbyWidget {...{ locale, amount, buttonLocation }} />
      )}
      <MisPayWidget {...{ locale, amount, buttonLocation }} />
      <MadfuWidget {...{ locale, amount, buttonLocation }} />
      <EmkanWidget {...{ locale, amount, buttonLocation }} />
    </div>
  );
};

export default WidgetsWrapper;
